<template>
  <div class="city-contain">
    <div v-if="selfItem.city_id" class="city-box bg">
      <div class="city-id">{{selfItem.index}}</div>
      <div class="right-box">
        <div class="line-box">
          <div class="city-name" :style="{width:maxWidth}">{{selfItem.cityShortName}}&#160;</div>
          <!-- <div class="line" :style="'width:' + (selfItem.count / maxLine) * 100 + '%'"></div> -->
        </div>
        <div class="mark">{{selfItem.count}}</div>
          <div class="rank-box up" v-if="selfItem.index - selfItem.lastIndex > 0"> ↑ {{selfItem.index - selfItem.lastIndex}}{{unit}}</div>
          <div class="rank-box down" v-if="selfItem.index - selfItem.lastIndex < 0">↓ {{selfItem.lastIndex - selfItem.index}}{{unit}}</div>
          <div class="rank-box" v-if="selfItem.index-selfItem.lastIndex === 0">持平</div>
      </div>
    </div>
    <div class="city-box" v-for="(item,index) in rankList" :key="'grayRank-' + index">
      <div class="city-id">{{index + 1}}</div>
      <div class="city-name" :style="{width:maxWidth}">&#160;{{item.cityShortName}}</div>
      <div class="right-box">
          <div class="mark">{{item.count}}{{unit}}</div>
          <div class="rank-box up" v-if="index-lastList[Number(item.city_id)].index > 0"> ↑ {{index-lastList[Number(item.city_id)].index}}{{unit}}</div>
          <div class="rank-box down" v-if="index-lastList[Number(item.city_id)].index < 0"> ↓ {{lastList[Number(item.city_id)].index-index}}{{unit}}</div>
          <div class="rank-box" v-if="index-lastList[Number(item.city_id)].index === 0">持平</div>
      </div>
    </div>
  </div>
</template>

<script>
    export default {
        name: 'grayRankCharts',
        props: {
            'rankList': Array,
            unit: {
                type: String,
                default: '分'
            }
        },
        data () {
            return {
                maxWidth: '30px',
                lastList: []
            }
        },
        computed: {
            maxLine () {
                this.handleShowAll(false);
                return this.rankList[0].count || 0;
            },
            selfItem () {
                this.sortList(this.rankList)
                let tmpItem = {};
                this.rankList.forEach((item, index) => {
                    let obj = JSON.parse(JSON.stringify(item))
                    if (Number(obj.city_id) === Number(this.selfId) && Number(obj.city_id) > 0) {
                        obj.index = index + 1;
                        let last = JSON.parse(JSON.stringify(this.lastList[Number(obj.city_id)].index))
                        obj.lastIndex = last + 1
                        tmpItem = obj;
                    }
                })
                if (this.selfId > 0) {
                    this.$emit('setSelfItem', this.indexKey, tmpItem)
                }
                return tmpItem;
            }
        },
        mounted () {
            let nameArry = []
            console.log('this.rankList:', this.rankList)
            if (this.rankList.length > 0) {
                for (let index = 0; index < this.rankList.length; index++) {
                    nameArry.push(this.rankList[index].city || this.rankList[index].cityShortName)
                }
                var longest = nameArry.sort(function (a, b) { return b.length - a.length; })[0];
                this.maxWidth = longest.length * 18.5 + 'px'
            }
        },
        methods: {
            sortList (list) {
                list.sort((x, y) => {
                    return y.count - x.count
                })
                let lastList = list
                lastList.sort((x, y) => {
                    return y.previousCount - x.previousCount
                })
                let arr = {}
                lastList.forEach((item, key) => {
                    item.index = key
                    arr[Number(item.city_id)] = item
                })
                this.lastList = arr
                return list
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
.city-contain{
  width: 100%;
  height: 253px;
  overflow-y: scroll;
  padding: 0 12px 0 14px;
  background: #F8F8F8;
  .city-box{
    border-bottom: 1px solid #eeeeee;
    height: 36px;
    width: 100%;
    display: flex;
    align-items: center;
    .city-id{
      width: 20px;
    }
    .city-name{
      display: flex;
      // justify-content: flex-end;
      font-size:10px;
      font-family:PingFangSC-Regular,PingFang SC;
      font-weight:400;
      color:rgba(51,51,51,1);
      line-height:10px;
      white-space: nowrap;
    }
    .right-box{
      margin-left: 12px;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      width: 100%;
      .line-box{
        display: flex;
        align-items: center;
        justify-content: flex-start;
        width: 100%;
        .line{
          height: 6px;
          background: #36B374;
        }
      }
      .mark{
        font-size:10px;
        font-family:PingFangSC-Regular,PingFang SC;
        font-weight:400;
        color:rgba(51,51,51,1);
        line-height:10px;
        margin-left: 12px;
        white-space: nowrap;
      }
      .rank-box {
        width: 54px;
        padding-right: 10px;
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        text-align: right;
        color: #2283e6;
        &.up {
          color: #36b374;
        }

        &.down {
          color: #ff4d4d;
        }
      }
    }
  }
}
</style>
